import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';
import { MuiAnimationTiming } from '../../utility';

export const tabAnimation = trigger('tab', [
  transition('* => *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(0.5rem)' }),
        animate(MuiAnimationTiming.EASE_OUT, style({ opacity: 1, transform: 'none' })),
        query('@*', [animateChild()], { optional: true })
      ],
      { optional: true }
    )
  ])
]);
